import axios from "axios";

const SERVICES_URL = process.env.SERVICES_URL;
const API_URL = `${SERVICES_URL}/lookup`;

export const getGenderOptions = (): Promise<any> =>
    axios.get(`${API_URL}/gender`).then(response => response.data);

export const getLocationOptions = (): Promise<any> =>
    axios.get(`${API_URL}/location`).then(response => response.data);

export const getRoleOptions = (): Promise<any> =>
    axios.get(`${API_URL}/role`).then(response => response.data);

export const getLkupByName = (lkupName: string): Promise<any> => {
    return axios.get(`${API_URL}/${lkupName}`).then(response => response.data);
};
